import styled from "styled-components";
import { SecondaryButton } from "@shape/reef-shared";

export const SeeMatrixSecondaryButton = styled(SecondaryButton)`
  height: 36px;
`;
